import apiClient from '../lib/axios';

export const login = async (credentials) => {
  const { data } = await apiClient.post('/api/auth/login', credentials);
  return data;
};

export const fetchProfile = async () => {
  const { data } = await apiClient.get('/api/auth/profile');
  return data;
};

export const requestPasswordReset = async (payload) => {
  const { data } = await apiClient.post('/api/auth/forgot-password', payload);
  return data;
};

export const resetPassword = async ({ token, body }) => {
  const { data } = await apiClient.post(`/api/auth/reset-password/${token}`, body);
  return data;
};

export const changePassword = async (body) => {
  const { data } = await apiClient.patch('/api/auth/change-password', body);
  return data;
};

export const refreshToken = async () => {
  const { data } = await apiClient.post('/api/auth/refresh-token');
  return data;
};



export const logout = async (payload) => {
  try {
    const { data } = await apiClient.post('/api/auth/logout', payload);
    return data;
  } catch (error) {
    // If the session is already invalid/expired, treat 401/403 as a successful logout
    const status = error?.response?.status;
    if (status === 401 || status === 403) {
      return {
        success: true,
        message: 'Session already invalid. Logged out locally.',
      };
    }
    throw error;
  }
};

export const register = async (payload) => {
  const { data } = await apiClient.post('/api/auth/register', payload);
  return data;
};



